import React from "react";
import NoDataFound from "./images/no-data.svg";
import { Grid } from "@mui/material";

interface NoDataSVGProps {
  dynamicText?: string;
}

const NoDataSVG: React.FC<NoDataSVGProps> = ({
  dynamicText = "No data found",
}) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
      }}
    >
      <Grid item xs={12} md={4} style={{ textAlign: "center" }}>
        <div style={{ textAlign: "center" }}  >
          <img src={NoDataFound} alt="" width="50%" height="50%"/>

          <p
            style={{
              color: "#666666",
              fontSize: 20,
              userSelect: "none",
              margin: 0, // Remove default margin
              padding: 0, // Optional, remove padding if any
              fontWeight: 500,
            }}
          >
            {dynamicText}
          </p>
        </div>
      </Grid>
    </Grid>
  );
};

export default NoDataSVG;
